interface ErrorContext {
    enabled?: boolean;
    level?: string;
    contexts?: { [key: string]: any };
}

export type ErrorWithContext = Error & ErrorContext;

const defaultErrorContext: ErrorContext = { enabled: true, level: 'error' };

export class WidgetError extends Error implements ErrorWithContext {
    override message: string;
    contexts: { widgetError: ErrorContext['contexts'] };

    constructor(message: string, contexts?: ErrorContext['contexts']) {
        super(message);

        this.message = message;
        this.contexts = { widgetError: contexts };
    }
}

function isErrorContext(value: any): value is ErrorContext {
    return !!(value && value.contexts);
}

export function handleError(message: string, context?: ErrorContext | unknown): void {
    let errorContext: ErrorContext;

    if (!isErrorContext(context)) {
        errorContext = { ...defaultErrorContext, ...{ contexts: { context } } };
    } else {
        errorContext = { ...defaultErrorContext, ...context };
    }

    const tracker = (window as any).TrackerService;

    if (errorContext.enabled && tracker) {
        tracker.captureMessage(message, errorContext.level, errorContext.contexts);
    }

    if (errorContext.level === 'error') {
        console.error(message, errorContext.contexts);
    } else {
        console.warn(message, errorContext.contexts);
    }
}
